module.exports = __webpack_public_path__ + "static/knollova-a60970b25ec3d180eacab656ed8858b0.jpg";